import { t } from "components/CentralDataMangement/translation/Translation";
import type { OMTargetAchievedData } from "../Annotations";
import TableTitle from "components/common/atoms/TableTitle";

interface RecruiterTargetProps {
    data?: OMTargetAchievedData;
    tableTitle?: string;
    isForeign?: boolean;
}

const OMTargetTable: React.FC<RecruiterTargetProps> = ({ data, tableTitle, isForeign }) => {


    return (
        <>
            {tableTitle &&
                <TableTitle title={tableTitle} />
            }
            <table className="table table-hover table-bordered targetTable">
                <thead>
                    <tr className="TableHeader">
                        <th></th>
                        <th className="text-center">{t("Target")}</th>
                        <th className="text-center">{t("Achieved")}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{t("Visits")}</td>
                        <td className="text-center">{data?.visits?.target ?? '-'}</td>
                        <td className="text-center">{data?.visits?.achieved ?? '-'}</td>
                    </tr>
                    <tr>
                        <td>{t("Workplace visits")}</td>
                        <td className="text-center">{data?.workplace_visit?.target ?? '-'}</td>
                        <td className="text-center">{data?.workplace_visit?.achieved ?? '-'}</td>
                    </tr>
                    {!isForeign &&
                    <tr>
                        <td>{t("Vacancies")}</td>
                        <td className="text-center">{data?.vacancies?.target ?? '-'}</td>
                        <td className="text-center">{data?.vacancies?.achieved ?? '-'}</td>
                    </tr>
                    }
                    <tr>
                        <td>{t("Vacancies FRO")}</td>
                        <td className="text-center">{data?.vacancies_fro?.target ?? '-'}</td>
                        <td className="text-center">{data?.vacancies_fro?.achieved ?? '-'}</td>
                    </tr>
                    <tr>
                        <td>{t("Prospect call")}</td>
                        <td className="text-center">{data?.prospect_calls?.target ?? '-'}</td>
                        <td className="text-center">{data?.prospect_calls?.achieved ?? '-'}</td>
                    </tr>
                    <tr>
                        <td>{t("Starter")}</td>
                        <td className="text-center">{data?.starter?.target ?? '-'}</td>
                        <td className="text-center">{data?.starter?.achieved ?? '-'}</td>
                    </tr>
                    <tr>
                        <td>{t("Stopper")}</td>
                        <td className="text-center">{data?.stopper?.target ?? '-'}</td>
                        <td className="text-center">{data?.stopper?.achieved ?? '-'}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export default OMTargetTable;